const color = {
  firstColor: "#2e0b57",
  borderColor: "#2E0A57",
  textColor: "#35185A",
  secondColor:'#eae3f3',
  thirdColor:'#841aff',
  forthColor:'#5a2c91',
};

export default color;
